import { Container, Perfil, Header as HeaderStyled } from './styles';
import { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useUser } from '../../hooks/useUser';
import { Loader } from '../Loader/Loader';
import { CiMenuKebab } from 'react-icons/ci';
// import { FaChevronRight } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
// import ModalMonitore from '../Modals/ModalMonitore';

interface HeaderProps {
  title: string;
  icon: ReactElement;
  children?: ReactNode;
}

interface CompanyProps {
  id_credor: number;
  credor: string;
  nome_credor: string;
  conta_parcelamento: number;
  id_contratante: string;
  logo: string | null;
  credor_crm: number;
}

interface CredorProps {
  id_usuario_credor: string;
  id_usuario: number;
  id_credor: number;
  credor_infos: CompanyProps;
}

export const Header = ({ children, title, icon }: HeaderProps) => {
  const path = useLocation();
  const [loading, setLoading] = useState(false);
  // const [modalIsOpen, setModalIsOpen] = useState(false);
  const {
    user,
    currentCompany,
    setCurrentCompany,
    loadUser,
    setUser,
    setIsOpen,
  } = useUser();

  function handleSetCompany(id: number) {
    setLoading(true);
    const currentCompany = user.credors.find(
      (cred) => cred.credor_infos.credor_crm === id,
    );
    if (currentCompany) {
      setCurrentCompany(currentCompany);
    }
    setLoading(false);
  }

  async function getUserInfos() {
    setLoading(true);
    await loadUser(localStorage.getItem('access_token')!);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    const storedUser = JSON.parse(localStorage.getItem('user')!);
    const storedCredors = JSON.parse(localStorage.getItem('credores')!);
    const storedInfos = {
      user: storedUser,
      credors: storedCredors,
    };
    setUser(storedInfos);
    setLoading(false);
  }

  useEffect(() => {
    getUserInfos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Container>
      {loading && <Loader />}
      <HeaderStyled path={path.pathname.replace('/', '')}>
        <button className="menu" onClick={() => setIsOpen(true)}>
          <CiMenuKebab />
        </button>
        <div className="title">
          {icon}
          <h1>{title}</h1>
        </div>
        {/* <Monitore>
          <p>
            <strong>Status da aplicação</strong>
          </p>
          <div onClick={() => setModalIsOpen(true)}>
            <div />
            <span>ONLINE</span>
            <FaChevronRight />
          </div>
          <ModalMonitore isOpen={modalIsOpen} setIsOpen={setModalIsOpen} />
        </Monitore> */}
        <Perfil>
          <img
            src={currentCompany.credor_infos.logo!}
            alt={currentCompany.credor_infos.nome_credor}
          />
          <div>
            <h3>{user.user.nome}</h3>
            <select
              value={currentCompany.id_credor}
              onChange={(e) => handleSetCompany(Number(e.target.value))}
            >
              {user.credors.map((company: CredorProps) => (
                <option value={company.id_credor} key={company.id_credor}>
                  {company.credor_infos.nome_credor}
                </option>
              ))}
            </select>
          </div>
        </Perfil>
      </HeaderStyled>
      {children}
    </Container>
  );
};
